import css from 'styled-jsx/css';

const styles = css.global`#financiamento-moto .linear-gradiente {
    height: 100%;
    position: absolute;
    width: 100%;
    opacity: 0.25;
    background: var(--Red-Red-Boston-01, #C00);
    mix-blend-mode: darken;
}

#financiamento-moto .container-imagem {
    position: relative;
}

#financiamento-moto .c2c-stack-title {
    margin-top: 24px;
}

#financiamento-moto .btn-simule {
    width: 100%;
    height: 48px;
    max-width: 272px;
    margin: auto;
}


@media(max-width: 992px) {
    
    #financiamento-moto .c2c-stack-content-veiculo {
        margin-top: 40px;
    }

    #financiamento-moto .container-imagem img {
        width: 100%;
    }
}

@media(min-width: 992px) {
    #financiamento-moto .container-imagem.mobile {
        display: none;
    }

    #financiamento-moto .container-imagem {
        margin-right: 100px;
    }

    .container-imagem img {
        border-radius: 4px;
    }

    #financiamento-moto .c2c-stack-content-veiculo {
        height: 650px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-around;
    }

    .container-imagem.desktop {
        display: flex;
    }

    #financiamento-moto .btn-simule {
        max-width: 272px;
    }
}`;

export default styles;